import React from 'react';

export default function PageHeader({ title, description, breadcrumbs, actions, testId = 'page-header' }) {
  return (
    <div className="mb-6 flex items-start justify-between gap-4" data-testid={testId}>
      <div>
        {breadcrumbs && (
          <div className="text-xs text-zinc-500 mb-2 font-mono uppercase tracking-wider">
            {breadcrumbs.map((b, i) => (
              <span key={i}>
                {i > 0 && <span className="mx-1.5 text-zinc-400">/</span>}
                {b}
              </span>
            ))}
          </div>
        )}
        <h1 className="font-display text-2xl md:text-3xl font-bold text-zinc-950 tracking-tight" data-testid="page-title">{title}</h1>
        {description && <p className="text-sm text-zinc-500 mt-1.5 max-w-2xl">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
}
